import { translate } from 'secullum-i18n';

export const IncluirPontoKeys = {
  DISPOSITIVO_AUTORIZADO: 'incluir-ponto-dispositivo-autorizado',
  PERMISSAO_LOCALIZACAO: 'incluir-ponto-permissao-localizacao',
  SERVICO_LOCALIZACAO: 'incluir-ponto-servico-localizacao',
  ULTIMA_LOCALIZACAO: 'incluir-ponto-ultima-localizacao',
  BUSCANDO_COORDENADAS: 'incluir-ponto-buscando-coordenadas',
  DATA_HORA_AUTOMATICA: 'incluir-ponto-data-hora-automatica',
  NOVA_INCLUSAO: 'incluir-ponto-nova-inclusao',
  ULTIMAS_BATIDAS: 'incluir-ponto-ultimas-batidas',
  LOCALIZACAO_FICTICIA: 'incluir-ponto-localizacao-ficticia',
  BUSCANDO_ENDERECO: 'incluir-ponto-buscando-endereco'
};

export const getIncluirPontoMessage = (key: string) => {
  const msg = IncluirPontoMessages.get(key);
  return msg ? translate(msg) : '';
};

const IncluirPontoMessages = new Map<string, string>([
  [
    IncluirPontoKeys.DISPOSITIVO_AUTORIZADO,
    'Verificando dispositivo autorizado'
  ],
  [
    IncluirPontoKeys.PERMISSAO_LOCALIZACAO,
    'Verificando permissão de localização'
  ],
  [IncluirPontoKeys.SERVICO_LOCALIZACAO, 'Verificando serviço localização'],
  [IncluirPontoKeys.ULTIMA_LOCALIZACAO, 'Buscando última localização'],
  [IncluirPontoKeys.BUSCANDO_COORDENADAS, 'Buscando coordenadas'],
  [IncluirPontoKeys.DATA_HORA_AUTOMATICA, 'Verificando data e hora automática'],
  [
    IncluirPontoKeys.NOVA_INCLUSAO,
    'Carregando informações nova inclusão manual'
  ],
  [IncluirPontoKeys.ULTIMAS_BATIDAS, 'Carregando últimas batidas'],
  [IncluirPontoKeys.LOCALIZACAO_FICTICIA, 'Validando localização fictícia']
]);
